// HKDSE Type E (詞) Quiz Data
// 系統化分類測驗數據，為後續 Supabase 後端數據遷移做準備

const hkdseTypeEQuizData = {
  // E1: 諸葛亮《出師表》
  'hkdse-e1-zhugeliang-chushibiao': {
    keyPoints: {
      title: '重點概念',
      questions: [
        {
          id: 'e1-kp-1',
          question: '《虞美人》的核心情感是什麼？',
          options: [
            'A. 思鄉之情',
            'B. 亡國之痛',
            'C. 人生感慨',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '詞中表達了思鄉之情、亡國之痛和人生感慨等多重情感。',
          points: 10
        },
        {
          id: 'e1-kp-2',
          question: '「春花秋月何時了」表達了什麼？',
          options: [
            'A. 對美景的讚美',
            'B. 對時光流逝的感慨',
            'C. 對亡國的痛苦',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '這句話表達了對時光流逝的感慨和亡國的痛苦。',
          points: 10
        },
        {
          id: 'e1-kp-3',
          question: '李煜如何表達亡國之痛？',
          options: [
            'A. 直接抒情',
            'B. 借景抒情',
            'C. 托物言志',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '李煜通過直接抒情、借景抒情和托物言志等多種手法表達亡國之痛。',
          points: 10
        }
      ]
    },
    argumentationMethods: {
      title: '論證手法',
      questions: [
        {
          id: 'e1-am-1',
          question: '詞中如何論證「人生無常」？',
          options: [
            'A. 通過對比',
            'B. 通過比喻',
            'C. 通過舉例',
            'D. 通過反證'
          ],
          correctAnswer: 'A',
          explanation: '詞中通過對比過去與現在來論證人生無常。',
          points: 10
        },
        {
          id: 'e1-am-2',
          question: '李煜如何突出亡國之痛？',
          options: [
            'A. 直接描述',
            'B. 通過對比',
            'C. 通過比喻',
            'D. 通過誇張'
          ],
          correctAnswer: 'B',
          explanation: '李煜通過對比亡國前後的境遇來突出亡國之痛。',
          points: 10
        }
      ]
    },
    writingTechniques: {
      title: '寫作手法',
      questions: [
        {
          id: 'e1-wt-1',
          question: '詞的結構特點是什麼？',
          options: [
            'A. 上下闋',
            'B. 起承轉合',
            'C. 並列式',
            'D. 遞進式'
          ],
          correctAnswer: 'A',
          explanation: '詞採用上下闋的結構，上闋寫景，下闋抒情。',
          points: 10
        },
        {
          id: 'e1-wt-2',
          question: '詞的語言特色是什麼？',
          options: [
            'A. 樸實深沉',
            'B. 華麗典雅',
            'C. 豪放奔放',
            'D. 含蓄委婉'
          ],
          correctAnswer: 'B',
          explanation: '詞語言華麗典雅，體現了李煜的藝術風格。',
          points: 10
        }
      ]
    },
    rhetoricalDevices: {
      title: '修辭手法',
      questions: [
        {
          id: 'e1-rd-1',
          question: '「問君能有幾多愁」運用了什麼修辭？',
          options: [
            'A. 比喻',
            'B. 誇張',
            'C. 設問',
            'D. 對偶'
          ],
          correctAnswer: 'C',
          explanation: '這句話運用了設問修辭，增強了抒情效果。',
          points: 10
        },
        {
          id: 'e1-rd-2',
          question: '詞中的比喻有什麼作用？',
          options: [
            'A. 增強形象性',
            'B. 突出特點',
            'C. 深化主題',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '比喻既能增強形象性，又能突出特點，還能深化主題。',
          points: 10
        }
      ]
    }
  },

  // E2: 蘇軾《水調歌頭》
  'hkdse-e2-sushi-shuidiaogetou': {
    keyPoints: {
      title: '重點概念',
      questions: [
        {
          id: 'e2-kp-1',
          question: '《水調歌頭》的核心主題是什麼？',
          options: [
            'A. 思鄉之情',
            'B. 人生哲理',
            'C. 兄弟之情',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '詞中表達了思鄉之情、人生哲理和兄弟之情等多重主題。',
          points: 10
        },
        {
          id: 'e2-kp-2',
          question: '「人有悲歡離合」表達了什麼？',
          options: [
            'A. 人生無常',
            'B. 世事難料',
            'C. 人生哲理',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '這句話表達了人生無常、世事難料和人生哲理。',
          points: 10
        },
        {
          id: 'e2-kp-3',
          question: '蘇軾如何表達對弟弟的思念？',
          options: [
            'A. 直接抒情',
            'B. 借月抒情',
            'C. 托物言志',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '蘇軾通過直接抒情、借月抒情和托物言志等多種手法表達思念。',
          points: 10
        }
      ]
    },
    argumentationMethods: {
      title: '論證手法',
      questions: [
        {
          id: 'e2-am-1',
          question: '詞中如何論證「人生哲理」？',
          options: [
            'A. 通過對比',
            'B. 通過比喻',
            'C. 通過舉例',
            'D. 通過反證'
          ],
          correctAnswer: 'A',
          explanation: '詞中通過對比月亮的圓缺與人生的悲歡來論證人生哲理。',
          points: 10
        },
        {
          id: 'e2-am-2',
          question: '蘇軾如何突出思鄉之情？',
          options: [
            'A. 直接描述',
            'B. 通過對比',
            'C. 通過比喻',
            'D. 通過誇張'
          ],
          correctAnswer: 'B',
          explanation: '蘇軾通過對比故鄉與他鄉來突出思鄉之情。',
          points: 10
        }
      ]
    },
    writingTechniques: {
      title: '寫作手法',
      questions: [
        {
          id: 'e2-wt-1',
          question: '詞的結構特點是什麼？',
          options: [
            'A. 上下闋',
            'B. 起承轉合',
            'C. 並列式',
            'D. 遞進式'
          ],
          correctAnswer: 'A',
          explanation: '詞採用上下闋的結構，上闋寫景，下闋抒情。',
          points: 10
        },
        {
          id: 'e2-wt-2',
          question: '詞的語言特色是什麼？',
          options: [
            'A. 樸實深沉',
            'B. 華麗典雅',
            'C. 豪放奔放',
            'D. 含蓄委婉'
          ],
          correctAnswer: 'C',
          explanation: '詞語言豪放奔放，體現了蘇軾的豪放派風格。',
          points: 10
        }
      ]
    },
    rhetoricalDevices: {
      title: '修辭手法',
      questions: [
        {
          id: 'e2-rd-1',
          question: '「明月幾時有」運用了什麼修辭？',
          options: [
            'A. 比喻',
            'B. 誇張',
            'C. 設問',
            'D. 對偶'
          ],
          correctAnswer: 'C',
          explanation: '這句話運用了設問修辭，增強了抒情效果。',
          points: 10
        },
        {
          id: 'e2-rd-2',
          question: '詞中的對偶有什麼作用？',
          options: [
            'A. 增強節奏',
            'B. 突出對比',
            'C. 深化主題',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '對偶既能增強節奏，又能突出對比，還能深化主題。',
          points: 10
        }
      ]
    }
  },

  // E3: 辛棄疾《青玉案》
  'hkdse-e3-xinqiji-qingyuan': {
    keyPoints: {
      title: '重點概念',
      questions: [
        {
          id: 'e3-kp-1',
          question: '《青玉案》的核心主題是什麼？',
          options: [
            'A. 愛情',
            'B. 理想追求',
            'C. 人生感慨',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '詞中表達了愛情、理想追求和人生感慨等多重主題。',
          points: 10
        },
        {
          id: 'e3-kp-2',
          question: '「眾裡尋他千百度」表達了什麼？',
          options: [
            'A. 尋找愛情',
            'B. 追求理想',
            'C. 人生艱難',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '這句話表達了尋找愛情、追求理想和人生艱難。',
          points: 10
        },
        {
          id: 'e3-kp-3',
          question: '辛棄疾如何表達理想追求？',
          options: [
            'A. 直接抒情',
            'B. 借景抒情',
            'C. 托物言志',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '辛棄疾通過直接抒情、借景抒情和托物言志等多種手法表達理想追求。',
          points: 10
        }
      ]
    },
    argumentationMethods: {
      title: '論證手法',
      questions: [
        {
          id: 'e3-am-1',
          question: '詞中如何論證「理想追求」？',
          options: [
            'A. 通過對比',
            'B. 通過比喻',
            'C. 通過舉例',
            'D. 通過反證'
          ],
          correctAnswer: 'A',
          explanation: '詞中通過對比追求過程的艱難與最終的收穫來論證理想追求。',
          points: 10
        },
        {
          id: 'e3-am-2',
          question: '辛棄疾如何突出愛情的美好？',
          options: [
            'A. 直接描述',
            'B. 通過對比',
            'C. 通過比喻',
            'D. 通過誇張'
          ],
          correctAnswer: 'C',
          explanation: '辛棄疾通過豐富的比喻來突出愛情的美好。',
          points: 10
        }
      ]
    },
    writingTechniques: {
      title: '寫作手法',
      questions: [
        {
          id: 'e3-wt-1',
          question: '詞的結構特點是什麼？',
          options: [
            'A. 上下闋',
            'B. 起承轉合',
            'C. 並列式',
            'D. 遞進式'
          ],
          correctAnswer: 'A',
          explanation: '詞採用上下闋的結構，上闋寫景，下闋抒情。',
          points: 10
        },
        {
          id: 'e3-wt-2',
          question: '詞的語言特色是什麼？',
          options: [
            'A. 樸實深沉',
            'B. 華麗典雅',
            'C. 豪放奔放',
            'D. 含蓄委婉'
          ],
          correctAnswer: 'C',
          explanation: '詞語言豪放奔放，體現了辛棄疾的豪放派風格。',
          points: 10
        }
      ]
    },
    rhetoricalDevices: {
      title: '修辭手法',
      questions: [
        {
          id: 'e3-rd-1',
          question: '「東風夜放花千樹」運用了什麼修辭？',
          options: [
            'A. 比喻',
            'B. 誇張',
            'C. 對偶',
            'D. 擬人'
          ],
          correctAnswer: 'B',
          explanation: '這句話運用了誇張修辭，突出了花燈的壯觀。',
          points: 10
        },
        {
          id: 'e3-rd-2',
          question: '詞中的比喻有什麼作用？',
          options: [
            'A. 增強形象性',
            'B. 突出特點',
            'C. 深化主題',
            'D. 以上皆是'
          ],
          correctAnswer: 'D',
          explanation: '比喻既能增強形象性，又能突出特點，還能深化主題。',
          points: 10
        }
      ]
    }
  }
};

// Helper functions
export const getTypeEQuizData = () => {
  return hkdseTypeEQuizData;
};

export const getTypeEQuizByType = (textId, categoryType) => {
  const quizData = hkdseTypeEQuizData[textId];
  if (!quizData) return null;

  const categoryData = quizData[categoryType];
  if (!categoryData) return null;

  // Convert questions to match the expected format
  const convertedQuestions = categoryData.questions.map(question => ({
    ...question,
    correct: question.correctAnswer.charCodeAt(0) - 65, // Convert 'A' to 0, 'B' to 1, etc.
    type: 'multiple-choice'
  }));

  return {
    title: categoryData.title,
    questions: convertedQuestions,
    timeLimit: 300, // 5 minutes
    totalPoints: categoryData.questions.reduce((sum, q) => sum + q.points, 0)
  };
};

export default hkdseTypeEQuizData;
